import {atom} from 'jotai';
import {ReactNode} from 'react';

type SnackbarAction = {
  text: string | ReactNode;
  onClick?: () => void;
  to?: string;
  openInNewTab?: boolean;
  buttonVariant?: 'outline' | 'transparent';
  buttonIconStart?: ReactNode;
};

export type SnackbarMessage = {
  text: string | ReactNode;
  action?: SnackbarAction;
  timeout?: number;
  accessory?: ReactNode;
};

export const snackbarAtom = atom<SnackbarMessage | null>(null);
